import { useCallback, useEffect, useState } from 'react';

// NetworkInformation API types
// https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
interface NetworkInformation extends EventTarget {
  // Effective connection type
  readonly effectiveType: '4g' | '3g' | '2g' | 'slow-2g';
  // Downlink speed in Mbps
  readonly downlink: number;
  // Event handling
  addEventListener(type: 'change', listener: () => void): void;
  removeEventListener(type: 'change', listener: () => void): void;
}
type NetworkMetrics = {
  networkSpeedType: string;
  downlink: number | null;
};
const DEFAULT_METRICS: NetworkMetrics = {
  networkSpeedType: 'unknown',
  downlink: null
};
export const useNetworkInfo = () => {
  const [metrics, setMetrics] = useState<NetworkMetrics>(DEFAULT_METRICS);
  const handleConnectionChange = useCallback((connection: NetworkInformation) => {
    setMetrics({
      networkSpeedType: connection.effectiveType,
      downlink: typeof connection.downlink === 'number' ? connection.downlink : null
    });
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // @ts-expect-error NetworkInformation API types not in lib
    const connection = window.navigator.connection;
    if (connection) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      handleConnectionChange(connection);
      const changeHandler = () => handleConnectionChange(connection);
      connection.addEventListener('change', changeHandler);
      return () => {
        connection.removeEventListener('change', changeHandler);
      };
    }
  }, [handleConnectionChange]);
  return metrics;
};